import { E_AlarmLevel, E_AlarmType } from "../enums"
import { IPageData, IPageParams } from "../types"
import { E_AlarmAttachType, E_AlarmMode, E_DealStatus, E_EventType, IAlarmProcessingAttachDTO, IAlarmRecordCountData } from "./alarm.types"
import { E_EmailType } from "./email.types"
import { E_Axis, E_SensorKlass } from "./sensor.types"

export enum E_IsRead {
    No = 1,
    Yes = 2,
}

export enum E_DiagnosisStatus {
    NotDiagnosis = 0,
    HasDiagnosis = 1,
}


export interface IAlaramCommonQuery {
    companyId: number
    areaId: number
    equipmentId: number
    sensorId: string
    sensorType: E_SensorKlass

    startTime: string
    endTime: string

    dealStatus?: E_DealStatus
}

export interface IAlaramCommonInfo {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId: number
    sensorId: string
    sensorType: E_SensorKlass
    mappingName: string
    companyName: string
    areaName: string
    equipmentName: string
}

export interface IAlaramCommonData1 {
    alarmAxis: E_Axis
    alarmValue: string
    alarmType: E_AlarmType

    azhigh: number
    battery: number
    // 包络
    envelopeX: number
    envelopeY: number
    envelopeZ: number

    // 峭度
    kurtX: number
    kurtY: number
    kurtZ: number

    // 波峰因数
    peakX: number
    peakY: number
    peakZ: number

    // 斜率
    slopeX: number
    slopeY: number
    slopeZ: number
    // 温度
    tem: number

    vx: number
    vy: number
    vz: number

    // 终端位移
    rx: number
    ry: number
    rz: number

    //报警时阈值，(温度/电压使用xcMax/xDMax)
    xcMax: number
    xdMax: number

    ycMax: number
    ydMax: number

    zcMax: number
    zdMax: number

    // /**
    //  * 可燃
    //  */
    // gasEx: number
    // /**
    //  * 硫化氢
    //  */
    // gasH2S: number
    // /**
    //  * 一氧化碳
    //  */
    // gasCO: number
    // /**
    //  * 氨气
    //  */
    // gasNH3: number
    // /**
    //  * 二氧化硫
    //  */
    // gasSO2: number
    // /**
    //  * 粉尘
    //  */
    // dust: number
}

export type IAlarmCenterGetEmailNoticeParams = IPageParams & Partial<{

    emailType: E_EmailType
    startTime: string
    endTime: string
} & IAlaramCommonQuery>

export interface IAlarmCenterEmailItem extends IAlaramCommonInfo {

    content: string
    emailType: E_EmailType

    receiveEmail: string
    createTime: string
    updateTime: string
    alarmType: E_AlarmType
}
export type IAlarmCenterGetEmailNoticeData =
    IPageData<IAlarmCenterEmailItem>


export type IAlarmCenterGetWeixinNoticeParam = IPageParams & Partial<{
    companyId: number
    areaId: number
    equipmentId: number
    sensorId: string
    sensorType: E_SensorKlass
    startTime: string
    endTime: string
    alarmTypeList: E_AlarmType[]
}>

export type IAlaramCenterWeixinItem = {
    alarmTime: string


    companyId: number
    areaId: number
    equipmentId: number
    mappingId: number
    sensorId: string
    sensorType: E_SensorKlass
    mappingName: string
    companyName: string
    areaName: string
    equipmentName: string
    receiveUser: string
} & IAlaramCommonData1

export type IAlarmCenterGetWeixinNoticeData = IPageData<IAlaramCenterWeixinItem>


export type IAlarmCenterHistoryStatisticsParams = Partial<IAlaramCommonQuery &
{
    mappingId: number
    alarmTypeList: E_AlarmType[]
    dealStatus: E_DealStatus
    level: E_AlarmLevel[]
    startTime: string
    endTime: string
}
>

export type IAlarmCenterHistoryListParams = IPageParams & Partial<{
    startTime: string
    endTime: string
} & IAlarmCenterHistoryStatisticsParams>

export type IAlarmCenterGetEquipmentAlaramHistoryListParams = IAlarmCenterHistoryListParams

export interface IAiDiagnosisConclusionItem {
    /**
     * 报警id
     */
    alarmId: number
    /**
     * 诊断结论
     */
    conclusion: string
    /**
     * 数据特征
     */
    feature: string
    /**
     * 建议措施
     */
    measure: string
}


export interface IAlarmHandleItem {
    handleTime?: string
    attachVOList?: IAlarmProcessingAttachDTO[]
    lastUser?: string
    remark?: string
}


export type IAlarmItem = IAlarmHandleItem & {
    aiDiagnosisConclusion: IAiDiagnosisConclusionItem[]
    aiDiagnosisStatus: number
    alarmAxis: E_Axis
    alarmLevel: E_AlarmLevel
    alarmMode: E_AlarmMode
    alarmNo: string
    /**
     * 连续报警次数
     */
    alarmTimes: number

    alaramType: E_AlarmType
    azhigh: number
    battery: number
    createTime: number
    /**
     * 特征值id
     */
    dataId: number

    dealStatus: E_DealStatus
    eventType: E_EventType

    id: number
    isRead: E_IsRead

    parentCompanyId: number

    vxFilter: number
    vyFilter: number
    vzFilter: number
    waveId: number

    /**
     * 可燃
     */
    gasEx: number
    /**
     * 硫化氢
     */
    gasH2S: number
    /**
     * 一氧化碳
     */
    gasCO: number
    /**
     * 氨气
     */
    gasNH3: number
    /**
     * 二氧化硫
     */
    gasSO2: number
    /**
     * 粉尘
     */
    dust: number


    /**     
     * 上传时间
     */
    sleepT: number
    /**
     * 上传时间-24H等新传感器使用
     */
    dataUpload: number

} & IAlaramCommonInfo & IAlaramCommonData1


export type IAlarmCenterGetEquipmentAlaramHistoryListData = IPageData<IAlarmItem>


export type IAlarmCenterGetEquipmentAlaramHistoryStatisticsParams = IAlarmCenterHistoryStatisticsParams

export interface IAlarmCenterStatisticsData {
    /**
     * 报警数量
     */
    alarmTotalNum: number
    /**
     * 报警设备数量
     */
    equipmentAlarmNum: number
    /**
     * 设备数量
     */
    equipmentTotalNum: number
    /**
     * 已处理测点数量
     */
    handlingMappingNum: number
    /**
     * 已处理数量
     */
    handlingNum: number
    /**
     * 报警测点数量
     */
    mappingAlarmNum: number
    /**
     * 测点数量
     */
    mappingTotalNum: number
    /**
     * 待处理测点数量
     */
    noHandlingMappingNum: number
    /**
     * 待处理数量
     */
    noHandlingNum: number
}

export type IAlarmCenterGetEquipmentAlaramHistoryStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetEquipmentAlaramListParams = IAlarmCenterHistoryListParams


export type IAlarmGgsItem = IAlaramCommonInfo & {
    /**
     * 气体
     */
    coLevel: E_AlarmLevel
    /**
     * 粉尘
     */
    dustLevel: E_AlarmLevel

    /**
     * 可燃
     */
    exLevel: E_AlarmLevel
    /**
     * 硫化氢
     */
    h2sLevel: E_AlarmLevel
    /**
     * 氨气
     */
    nh3Level: E_AlarmLevel
    /**
     * 二氧化硫
     */
    so2Level: E_AlarmLevel

    alarmId: number
    createTime: string
    dataId: number
    waveId: number
}

export interface IAlarmCenterEquipmentDTO extends IAlaramCommonInfo {
    alarmId: number
    bfLevel: E_AlarmLevel
    createTime: string
    dataId: number
    envLevel: E_AlarmLevel
    highAccLevel: E_AlarmLevel
    pointName: string
    qlevel: E_AlarmLevel
    temLevel: E_AlarmLevel
    vlevel: E_AlarmLevel
    waveId: number
    diagnosisStatus: E_DiagnosisStatus
}


export type IAlarmCenterGetEquipmentAlaramListData = IPageData<IAlarmCenterEquipmentDTO>


export type IAlarmCenterGetEquipmentAlaramStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterGetEquipmentAlaramStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetSensorAngleAlaramHistoryListParams = IAlarmCenterHistoryListParams
export type IAlarmCenterGetSensorAngleAlaramHistoryListData = IPageData<IAlarmItem>

export type IAlarmCenterGetSensorAngleAlaramHistoryStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterGetSensorAngleAlaramHistoryStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetSensorAngleAlaramListParams = IPageParams & Partial<IAlaramCommonQuery>

export type IAlarmCenterGetSensorAngleAlaramListData = IPageData<IAlarmCenterSensorItem>

export type IAlarmCenterGetSensorAngleAlaramStatisticsParams = Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorAngleAlaramStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetSensorBatteryAlaramHistoryListParams = IPageParams & Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorBatteryAlaramHistoryListData = IPageData<{}>


export type IAlarmCenterGetSensorBatteryAlaramHistoryStatisticsParams = Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorBatteryAlaramHistoryStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetSensorBatteryAlaramListParams = IPageParams & Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorBatteryAlaramListData = IPageData<IAlarmCenterSensorItem>

export type IAlarmCenterGetSensorBatteryAlaramStatisticsParams = Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorBatteryAlaramStatisticsData = IAlarmCenterStatisticsData


export type IAlarmCenterGetSensorOfflineAlaramHistoryList = IPageParams & Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorOfflineAlaramHistoryData = IPageData<IAlarmItem>

export type IAlarmCenterGetSensorOfflineAlaramHistoryStatisticsParams = Partial<IAlaramCommonQuery>

export type IAlarmCenterGetSensorOfflineAlaramHistoryStatisticsData =
    IAlarmCenterStatisticsData

export type IAlarmCenterGetSensorOfflineAlaramListParams = IPageParams & Partial<{
} & IAlaramCommonQuery>

export type IAlarmCenterSensorItem = {
    createTime: string
    dataId: number
    pointName: string
    waveId: number
} & IAlaramCommonInfo

export type IAlarmCenterGetSensorOfflineAlaramListData = IPageData<IAlarmCenterSensorItem>


export type IAlarmCenterGetSensorOfflineAlaramStatisticsParams = Partial<IAlaramCommonQuery>
export type IAlarmCenterGetSensorOfflineAlaramStatisticsData = IAlarmCenterStatisticsData


export interface IAttachVoItem {
    attachFileId: number
    attachTime: string
    attachType: E_AlarmAttachType
}

export interface IAlarmCenterDealAlarmRecordParams {
    alarmId: number
    attachVOList: IAttachVoItem[]
    dealUser: string
    remark: string
}

export type IAlarmCenterDealAlarmStatisticsParams = IAlarmCenterDealAlarmRecordParams

export type IAlarmCenterDealOfflineAlarmRecord = IAlarmCenterDealAlarmRecordParams


// 气体
export type IAlarmCenterEquipmentGasAlaramHistoryListParams = IAlarmCenterHistoryListParams
export type IAlarmCenterEquipmentGasAlaramHistoryData = IPageData<IAlarmItem>

export type IAlarmCenterEquipmentGasAlaramHistoryStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterEquipmentGasAlaramHistoryStatisticsData = IAlarmCenterStatisticsData

export type IAlarmCenterEquipmentGasAlaramListParams = IAlarmCenterHistoryListParams
export type IAlarmCenterEquipmentGasAlaramListData = IPageData<IAlarmGgsItem>

export type IAlarmCenterEquipmentGasAlaramStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterEquipmentGasAlaramStatisticsData = IAlarmCenterStatisticsData

// 粉尘
export type IAlarmCenterEquipmentGdsAlaramHistoryListParams = IAlarmCenterHistoryListParams
export type IAlarmCenterEquipmentGdsAlaramHistoryData = IPageData<IAlarmItem>

export type IAlarmCenterEquipmentGdsAlaramHistoryStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterEquipmentGdsAlaramHistoryStatisticsData = IAlarmCenterStatisticsData

export type IAlarmCenterEquipmentGdsAlaramListParams = IAlarmCenterHistoryListParams
export type IAlarmCenterEquipmentGdsAlaramListData = IPageData<IAlarmGgsItem>

export type IAlarmCenterEquipmentGdsAlaramStatisticsParams = IAlarmCenterHistoryStatisticsParams
export type IAlarmCenterEquipmentGdsAlaramStatisticsData = IAlarmCenterStatisticsData







